/**
 * Bundle Guard — Shopify theme 端防超賣
 * v4: 修正 cart page — Dawn theme 用 body.line 唔係 body.id
 */
(function() {
  var API = 'https://silvermine-pos.vercel.app/api/inventory-links?mode=limits';
  var bundleGroups = null;
  var variantToGroup = {};

  fetch(API)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (!data.success || !data.groups) return;
      bundleGroups = data.groups;
      for (var compId in bundleGroups) {
        var group = bundleGroups[compId];
        for (var variantId in group.members) {
          variantToGroup[variantId] = compId;
        }
      }
    })
    .catch(function() {});

  // Product page — capturing submit listener
  document.addEventListener('submit', async function(evt) {
    var form = evt.target;
    var productForm = form.closest('product-form');
    if (!productForm) return;

    if (productForm.dataset.bundleChecked === '1') {
      delete productForm.dataset.bundleChecked;
      return;
    }

    if (!bundleGroups) return;

    var formData = new FormData(form);
    var variantId = formData.get('id');
    var addQty = parseInt(formData.get('quantity') || '1', 10);

    var compId = variantToGroup[String(variantId)];
    if (!compId) return;

    var group = bundleGroups[compId];
    if (group.skip) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    var qtyPerUnit = group.members[String(variantId)] || 1;
    var baseNeeded = addQty * qtyPerUnit;

    try {
      var cartResp = await fetch('/cart.js');
      var cart = await cartResp.json();

      var currentUsage = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var itemCompId = variantToGroup[String(item.variant_id)];
        if (itemCompId === compId) {
          var itemQtyPer = group.members[String(item.variant_id)] || 0;
          currentUsage += item.quantity * itemQtyPer;
        }
      }

      var totalNeeded = currentUsage + baseNeeded;
      if (totalNeeded > group.available) {
        var remaining = Math.max(0, group.available - currentUsage);
        var maxCanAdd = Math.floor(remaining / qtyPerUnit);
        var msg = maxCanAdd > 0
          ? 'Not enough stock. You can add up to ' + maxCanAdd + '.'
          : 'Out of stock. Cannot add to cart.';
        if (productForm.handleErrorMessage) {
          productForm.handleErrorMessage(msg);
        } else {
          alert(msg);
        }
        return;
      }
    } catch (e) {}

    productForm.dataset.bundleChecked = '1';
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }, true);

  // Cart page — intercept fetch to /cart/change
  var origFetch = window.fetch;
  window.fetch = async function(url, options) {
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';

    if (bundleGroups && urlStr.includes('/cart/change') && options) {
      try {
        var body;
        if (options.body instanceof URLSearchParams) {
          body = Object.fromEntries(options.body);
        } else if (options.body instanceof FormData) {
          body = Object.fromEntries(options.body);
        } else if (typeof options.body === 'string') {
          body = JSON.parse(options.body);
        }

        if (body && body.quantity !== undefined && (body.id || body.line)) {
          var newQty = parseInt(body.quantity, 10);

          var cartResp = await origFetch.call(window, '/cart.js');
          var cart = await cartResp.json();

          // Find the changing item — by key (body.id) or line index (body.line, 1-based)
          var changingItem = null;
          if (body.id) {
            changingItem = cart.items.find(function(i) { return i.key === body.id; });
          } else if (body.line) {
            var idx = parseInt(body.line, 10) - 1;
            if (idx >= 0 && idx < cart.items.length) {
              changingItem = cart.items[idx];
            }
          }

          if (changingItem && newQty > changingItem.quantity) {
            var variantId = String(changingItem.variant_id);
            var compId = variantToGroup[variantId];

            if (compId) {
              var group = bundleGroups[compId];
              if (!group.skip) {
                var totalUsage = 0;
                for (var j = 0; j < cart.items.length; j++) {
                  var ci = cart.items[j];
                  var ciCompId = variantToGroup[String(ci.variant_id)];
                  if (ciCompId === compId) {
                    var ciQtyPer = group.members[String(ci.variant_id)] || 0;
                    if (ci.key === changingItem.key) {
                      totalUsage += newQty * ciQtyPer;
                    } else {
                      totalUsage += ci.quantity * ciQtyPer;
                    }
                  }
                }

                if (totalUsage > group.available) {
                  alert('Not enough stock. Please reduce the quantity.');
                  location.reload();
                  return new Response('{}', { status: 200, headers: { 'Content-Type': 'application/json' } });
                }
              }
            }
          }
        }
      } catch (e) {}
    }

    return origFetch.apply(window, arguments);
  };
})();